import { FC } from 'react';

export const HomeIcon: FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.61 8.86431L12.61 2.2217C12.4351 2.07795 12.2207 2 12 2C11.7793 2 11.5649 2.07795 11.39 2.2217L3.39 8.86431C3.26899 8.96379 3.17091 9.09156 3.10331 9.2378C3.03571 9.38405 3.00037 9.54489 3 9.70798V20.9321C3 21.2153 3.10536 21.4869 3.29289 21.6872C3.48043 21.8875 3.73478 22 4 22H10V15.5923H14V22H20C20.2652 22 20.5196 21.8875 20.7071 21.6872C20.8946 21.4869 21 21.2153 21 20.9321V9.70798C20.9996 9.54489 20.9643 9.38405 20.8967 9.2378C20.8291 9.09156 20.731 8.96379 20.61 8.86431ZM19 19.8641H16V13.4565H8V19.8641H5V10.2526L12 4.43234L19 10.2526V19.8641Z"
        fill="white"
        fillOpacity="0.5"
      />
    </svg>
  );
};
